export enum CompanyMemberRole {
    SoleProprietor = 40,
    BoardMember = 41
}

(CompanyMemberRole as any).__typeName = 'CompanyMemberRole';